import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getNextToJump,
  RaceCard,
  raceLink,
  timeToJump,
  fmtTime,
} from '../api/feeds';
import { betfairErrorMessage } from '../api/betfair';
import './Feeds.css';

const NextToJump: React.FC = () => {
  const [races, setRaces] = useState<RaceCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [now, setNow] = useState(Date.now());

  const load = useCallback(async () => {
    setError(null);
    try {
      setRaces(await getNextToJump(36));
    } catch (err) {
      setError(betfairErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  // Refetch the field every 30s; re-tick the countdowns every second.
  useEffect(() => {
    load();
    const refetch = setInterval(load, 30000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => {
      clearInterval(refetch);
      clearInterval(tick);
    };
  }, [load]);

  return (
    <div className="feed">
      <div className="feed-header">
        <div>
          <h1>Next To Jump</h1>
          <div className="feed-sub">Upcoming Australian races by jump time · live Betfair favourites</div>
        </div>
        <button className="feed-refresh" onClick={load} disabled={loading}>↻ Refresh</button>
      </div>

      {error && <div className="feed-error">{error}</div>}

      {loading && races.length === 0 ? (
        <div className="feed-loading">Loading upcoming races…</div>
      ) : races.length === 0 ? (
        <div className="feed-empty">
          <p>No upcoming races in the current Betfair data.</p>
          <Link to="/">Browse all meetings →</Link>
        </div>
      ) : (
        <div className="feed-grid">
          {races.map((race) => {
            const ttj = timeToJump(race.start_time, now);
            return (
              <Link
                key={race.market_id}
                to={raceLink(race.meeting, race.race_number, race.date)}
                className="race-card"
              >
                <div className="race-card-top">
                  <span className="race-card-meeting">{race.meeting}</span>
                  <span className={`ttj ttj--${ttj.cls}`}>
                    {race.in_play ? 'IN-PLAY' : ttj.label}
                  </span>
                </div>

                <div className="race-card-mid">
                  <div>
                    <div className="race-card-fav-label">Favourite</div>
                    <div className="race-card-fav-name">
                      {race.favourite ? race.favourite.runner_name : '—'}
                    </div>
                  </div>
                  <span className="race-card-fav-price">
                    {race.favourite ? race.favourite.price.toFixed(2) : '—'}
                  </span>
                </div>

                <div className="race-card-bottom">
                  <span className="race-card-race">R{race.race_number}</span>
                  <span>{fmtTime(race.start_time)} · {race.runner_count} runners</span>
                  {race.in_play ? (
                    <span className="badge-inplay">LIVE</span>
                  ) : (
                    <span className="badge-status">{race.status}</span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NextToJump;
